module.exports = __webpack_public_path__ + "img/SilentDeath.a00b071a.png";